import { useQuery } from "@tanstack/react-query";
import type { ApiCalculo } from "pages/calculo/types/ApiCalculo";
import type { ApiCalculoComposicao } from "pages/calculo/types/ApiCalculoComposicao";
import { apiRelEntradaLeite } from "pages/relatorios/api/apiRelEntradaLeite";
import { RelatorioContainer } from "pages/relatorios/components/RelatorioContainer";
import { useRelatorioStore } from "pages/relatorios/store";
import type { ApiRelatorioGetParams } from "pages/relatorios/types/ApiRelatorioParams";
import { buildRelatorioGetParams } from "pages/relatorios/utils/buildRelatorioGetParams";
import { useEffect, useMemo } from "react";
import type { TExportToCSV } from "std/csv";
import { roundAbnt } from "std/math";
import { FilterBar } from "./FilterBar";
import { columns, columnsItens, TableRelEntradaLeite } from "./TableRelEntradaLeite";

export function RelatorioEntradaLeite() {
	const filter = useRelatorioStore((s) => s.filter);

	const limparFiltros = useRelatorioStore((s) => s.limparFiltros);

	const params: ApiRelatorioGetParams = useMemo(() => buildRelatorioGetParams(filter), [filter]);

	const { data, isFetching, refetch } = useQuery({
		queryKey: ["apiRelEntradaLeite", params],
		queryFn: () => apiRelEntradaLeite({ params }),
		enabled: false,
	});

	const registros = useMemo(() => data?.registros || [], [data]);

	const csvData: TExportToCSV<ApiCalculo, ApiCalculoComposicao> = useMemo(() => {
		const totalVolume = roundAbnt((registros || []).reduce((acc, cur) => acc + cur.calc_volume, 0));

		return {
			type: "expandable",
			fileName: "relatorio-entrada-leite",
			options: {
				parentColumns: columns,
				childColumns: columnsItens(totalVolume),
				data: registros,
				childKey: "composicao",
			},
		};
	}, [registros]);

	useEffect(() => {
		limparFiltros();
	}, [limparFiltros]);

	const title = "Dados de Entrada de Leite";

	return (
		<RelatorioContainer
			breadCrumbs={["Relatórios", "Entrada", "Leite"]}
			refetch={refetch}
			filterBar={<FilterBar />}
			loading={isFetching}
			title={title}
			csvData={csvData}
			registros={registros}
			table={<TableRelEntradaLeite data={data?.registros} title={title} />}
		/>
	);
}
